import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { ELECTRIC_BOLT_STROKE_SRC, ELECTRIC_BOLT_FILL_SRC } from 'site-modules/shared/constants/top-rated/top-rated';

const electricBoltStrokeUrl = getStaticImageUrl(ELECTRIC_BOLT_STROKE_SRC);
const electricBoltFillUrl = getStaticImageUrl(ELECTRIC_BOLT_FILL_SRC);

export function ElectricBolt({ size, wrapperStyle = null, wrapperClass = null, childClass = 'pos-a top-0 left-0' }) {
  const sizeXY = `${size}px`;
  return (
    <span
      className={classnames('electric-bolt', wrapperClass)}
      style={{
        width: sizeXY,
        height: sizeXY,
        ...wrapperStyle,
      }}
    >
      <img
        className={classnames('is-fill', childClass)}
        src={electricBoltFillUrl}
        aria-hidden
        style={{
          width: sizeXY,
          height: sizeXY,
        }}
        alt=""
      />
      <img
        className={childClass}
        src={electricBoltStrokeUrl}
        aria-hidden
        style={{
          width: sizeXY,
          height: sizeXY,
        }}
        alt=""
      />
    </span>
  );
}

ElectricBolt.propTypes = {
  size: PropTypes.number.isRequired,
  wrapperStyle: PropTypes.shape({}),
  wrapperClass: PropTypes.string,
  childClass: PropTypes.string,
};
